import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'omit',
  standalone: false,
})
export class OmitPipe implements PipeTransform {
  transform<T, K extends keyof T>(items: T[], property: K): Omit<T, K>[] {
    if (!items) {
      return [];
    }

    if (!Array.isArray(items) || !property) {
      return items;
    }

    return items.map(item => {
      const { [property]: omitted, ...rest } = item;
      return rest;
    });
  }
}
